'use client'

// Proactive token refresh is now handled inside AuthProvider via a shared
// SWR loop and the module-level refresh lock (refreshLock.ts). This hook is
// kept as a no-op for backwards compatibility with existing call sites.
export function useAuthSession(): void {
  // intentional no-op
}
